import * as React from "react";

import { TimeBounds } from "@/shared/domain/topics/determineTimeBounds";
import { NS_PER_MS_BIGINT } from "@/shared/time";

/**
 * Pads time bounds used in charts to at least 2ms duration.
 *
 * The default x-axis tick provider is Date-based so chart ticks
 * with the default renderer will only show different values
 * if the time bounds on the chart are at least 2ms long.
 */
export function usePaddedTimeBounds(timeBounds: TimeBounds) {
  const padded = React.useMemo(() => {
    if (timeBounds.latest === undefined || timeBounds.earliest === undefined) {
      return timeBounds;
    }
    if (timeBounds.latest - timeBounds.earliest <= 2n * NS_PER_MS_BIGINT) {
      return {
        earliest: timeBounds.earliest - NS_PER_MS_BIGINT,
        latest: timeBounds.latest + NS_PER_MS_BIGINT,
      };
    }
    return timeBounds;
  }, [timeBounds]);
  return padded;
}
